import {http} from "@/assets/utils/api";

/***
 * 站内信列表
 */
export const getStationMessageList = (params) => http.get('/YymUserMessage/list',{params});

/**
 * 获取站内信未读数数量
 */
export const getStationUnReadNum = (params) => http.get('/YymUserMessage/unreadCount',{params});

/**
 * 站内信全部已读
 */
export const readAllStationMessage = (params) => http.post('/YymUserMessage/readAll',{params});